export default __webpack_public_path__ + "static/media/commonocean-sim.8d947764.md";